"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.getUserPartnerList = void 0;
var dispatcher_1 = require("@src/dispatcher");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
// API
var Api = __importStar(require("@src/api"));
// Utils
var _utils_1 = require("./_utils");
function getUserPartnerList(callback) {
    if (!_utils_1.userHasPermission(const_1.PERMISSION_LEVELS.MOGAMBO_ALL_VIEW)) {
        _utils_1.permissionErrorAlert('fetch user account list');
        return;
    }
    dispatcher_1.dispatch(MogamboConstants_1.ActionTypes.START_LOADING, {
        message: "Fetching User's Partner List.",
    });
    Api.getUserPartnerList(callback)
        .then(function (_a) {
        var success = _a.success, response = _a.response;
        if (callback)
            callback(success, response);
    })["catch"](function (error) {
        Api.captureException(error);
    });
}
exports.getUserPartnerList = getUserPartnerList;
exports["default"] = getUserPartnerList;
